export const SET_SEARCH_QUERY = '@searchquery/SET_SEARCH_QUERY';
export const SET_BRAND_FILTER = '@brandfilter/SET_BRAND_FILTER';
export const SET_PRODUCT_FILTER = '@productfilter/SET_PRODUCT_FILTER';
export const SET_SORT_OPTION = '@sortoption/SET_SORT_OPTION';
export const SET_FILTERED_ITEMS = '@filtereditem/SET_FILTERED_ITEMS';
export const SET_LOADING = '@loading/SET_LOADING';
export const SET_OFFSET = '@offset/SET_OFFSET'
export const SET_MORE_SCROLL = '@morescroll/SET_MORE_SCROLL'
